export default __webpack_public_path__ + "static/media/sv.550a67c0.webp";